import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "src/store";
import { endOfToday, startOfToday, subMonths } from "date-fns";

export interface ICoinTransfer {
  coinTransferFilter: {
    status: string;
    name: string;
    phone: string;
    channel: string;
    target: string;
    orderId: string;
    dateGte: Date | null;
    dateLte: Date | null;
  };
}

const initialState: ICoinTransfer = {
  coinTransferFilter: {
    status: "",
    name: "",
    phone: "",
    channel: "",
    target: "",
    orderId: "",
    dateGte: subMonths(startOfToday(), 1),
    dateLte: endOfToday(),
  },
};

type coinTransferFilter = {
  status?: string;
  name?: string;
  phone?: string;
  channel?: string;
  target?: string;
  orderId?: string;
  dateGte?: Date | null;
  dateLte?: Date | null;
};

export const coinTransferFilterSlice = createSlice({
  name: "thisCoinTransferFilter",
  initialState,
  reducers: {
    setCoinTransferFilter: (
      state,
      action: PayloadAction<coinTransferFilter>
    ) => {
      state.coinTransferFilter = {
        ...state.coinTransferFilter,
        ...action.payload,
      };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { setCoinTransferFilter } = coinTransferFilterSlice.actions;

export const getReloadLogFilter = (state: RootState) =>
  state.thisCoinTransferFilter.coinTransferFilter;

export default coinTransferFilterSlice.reducer;
